import React, { Component } from "react";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Dropdown, Row, Col, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiPlusCircle, FiTrash2, FiEdit3, FiImage, FiEye } from "react-icons/fi";
import {
  FaRegFilePdf,
  FaRegImage,
  FaRegFileExcel,
  FaRegFileWord,
  FaRegTrashAlt,
  FaPen,
  FaEye,
  FaCheck,
  FaTimes,
} from "react-icons/fa";
import { BsFileEarmarkArrowDown } from "react-icons/bs";
import { Link } from "react-router-dom";
import { optionMasterService } from "app/_services/OptionMasterService/optionMasterService";
import { ProjectService } from "app/_services/ProjectService/ProjectService";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import TableExport from "app/views/custom/components/Export/TableExport";
import LastLog from "app/views/custom/components/Logs/LastLog";
import toastr from "toastr";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import ApproveReject from "app/views/custom/components/ApproveReject/ApproveReject";
import { SetGlobalPermission } from "app/Components/SetPermission/Permissions";

class Company extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    companyData: [],
    projectData: {},
    projectId: this.props.match.params.id ? this.props.match.params.id : null,
  };

  defaultSorted = [
    {
      dataField: "name",
      order: "asc",
    },
  ];

  componentDidMount() {
    this.setCompanyData();
  }

  setCompanyData = async () => {
    let response = await optionMasterService.optionMasterByType("company", 0);

    if (response && response.status) {
      if (response.data && response.data.option_master) {
        this.setState(
          {
            companyData: response.data.option_master,
          },
          () => {
            let data = JSON.parse(JSON.stringify(this.state.companyData));
            Array.isArray(data) &&
              data.map((rowData, rowindex) => {
                rowData["sid"] = rowindex + 1;
              });
            this.setState({
              companyData: data,
            });
          }
        );
      }
    } else {
      this.setState({
        companyData: [],
      });
    }
  };

  delete(e, id, projectId) {
    e.preventDefault();

    confirmAlert({
      title: "Delete Organisation",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let response = await optionMasterService.deleteOptionMaster(id, projectId);

            if (response && response.status) {
              toastr.info(response.message || "Deleted Successfully!");
              this.setCompanyData();
            }
          },
        },
        {
          label: "No",
          onClick: () => console.log("test"),
        },
      ],
    });
  }

  paginationOptions = {
    // custom: true,
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: this.state.companyData.length,
  };

  render() {
    let { companyData } = this.state;
    let { SearchBar } = Search;
    let sortableColumn = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "metaValue",
        text: "Organisation Name",
        sort: true,
      },
      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          console.log("row", this);
          return (
            <div className="actionIconsGroup">
              <SetGlobalPermission
                permission="global_userMgmt_view"
                data={
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">View</Tooltip>}
                  >
                    <Link
                      to={"/user-management/company/view/" + row.id}
                      className="icons text-cyanBlue"
                    >
                      <FiEye />
                    </Link>
                  </OverlayTrigger>
                }
              />

              <SetGlobalPermission
                permission={
                  row.status == 1
                    ? "global_userMgmt_editAfterApprove"
                    : "global_userMgmt_edit"
                }
                data={
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
                  >
                    <Link
                      to={"/user-management/company/edit/" + row.id}
                      className="icons text-cyanBlue"
                    >
                      <FiEdit3 />
                    </Link>
                  </OverlayTrigger>
                }
              />

              {row.status == 1 ? (
                <SetGlobalPermission
                  permission="global_userMgmt_approve"
                  data={
                    <SetGlobalPermission
                      permission="global_userMgmt_delete"
                      data={
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                        >
                          <a
                            onClick={(e) => this.delete(e, row.id, row.projectId)}
                            href="#"
                            className="icons text-danger"
                          >
                            <FaRegTrashAlt />
                          </a>
                        </OverlayTrigger>
                      }
                    />
                  }
                />
              ) : (
                <SetGlobalPermission
                  permission="global_userMgmt_delete"
                  data={
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                    >
                      <a
                        onClick={(e) => this.delete(e, row.id, row.projectId)}
                        href="#"
                        className="icons text-danger"
                      >
                        <FaRegTrashAlt />
                      </a>
                    </OverlayTrigger>
                  }
                />
              )}

              <ApproveReject
                rowId={row.id}
                tableName={"option_master"}
                setData={this.setCompanyData}
                permission="global_userMgmt_approve"
                status={row.status}
              ></ApproveReject>
            </div>
          );
        },
      },
    ];
    return (
      <div>
        <MainBreadcrumb
          routeSegments={[
            { name: "User Management", path: "#" },
            { name: "Organisation", path: "#" },
          ]}
          breadCrumbsText="User_Management_Organization"
        />
        <div className="card p-4 mb-4">
          {/* <ToolkitProvider
            striped
            keyField="id"
            data={JSON.parse(JSON.stringify(companyData))}
            columns={sortableColumn}
            search
          >
            {(props) => (
              <>
                <div className="d-flex align-items-center justify-content-between pb-3">
                  <SearchBar {...props.searchProps} className="mb-0" />
                  <div className="btn-toolbar">
                    <SetGlobalPermission
                      permission="global_userMgmt_add"
                      data={
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-top">Add Organisation</Tooltip>}
                        >
                          <Link
                            className="icons btn-icon font-20 text-cyanBlue"
                            to="/user-management/company/add"
                          >
                            <FiPlusCircle />
                          </Link>
                        </OverlayTrigger>
                      }
                    />

                    <SetGlobalPermission
                      permission="global_userMgmt_download"
                      data={
                        <TableExport
                          tableName={"Company"}
                          dataColumn={sortableColumn}
                          renderData={companyData}
                          searchText={props.searchProps.searchText}
                        ></TableExport>
                      }
                    />
                  </div>
                </div>
                <div className="drilling-projectplan-table">
                  <BootstrapTable
                    {...props.baseProps}
                    bootstrap4
                    pagination={paginationFactory(this.paginationOptions)}
                    noDataIndication={"Table is empty"}
                  />
                </div>
              </>
            )}
          </ToolkitProvider> */}

          <SearchBootstrapTable
            searchKey={"companyDesktopSearch"}
            data={JSON.parse(JSON.stringify(companyData))}
            columns={sortableColumn}
            tableKey="company"
          />
        </div>
        <LastLog subModulename={"option-master-company"}></LastLog>
      </div>
    );
  }
}

export default Company;
